// import ShowLightbox from '../classes/ShowLightbox';
import ShowFadeLightbox from '../classes/ShowFadeLightbox';
import scrollElementTo from '../../lib/utils/animation/scrollElementTo';

/** Обозначение кнопки esc */
const VK_ESC: number = 27;
const SCREEN_WIDTH_SMALL: number = 980;
let isOpenedLightbox: boolean = false;
let scrollState: number = 0;

function main(): void
{
	const container = document.querySelector( 'main.vacancies' ) as HTMLElement;

	if ( !container )
	{
		return;
	}

	const listElementsContainer = container.querySelector( 'ul.vacancies' ) as HTMLElement;
	
	if ( !listElementsContainer )
	{
		return;
	}
	
	const controls = container.querySelector( 'div.controls' ) as HTMLElement;
	const buttonClose = controls.querySelector('button.close') as HTMLButtonElement;
	
	let showFadeLightbox: ShowFadeLightbox;
	let unRegisterHandlers: () => void;

	if ( listElementsContainer.children.length > 0 )
	{
		showFadeLightbox = new ShowFadeLightbox( listElementsContainer.children, controls );
	}

	/** Клик мимо */
	const boundDocumentClickHandler: ( event: Event ) => void = ( event ) =>
	{
		if ( ( event.target as HTMLElement).classList.contains( 'lightbox' ) )
		{
			event.stopPropagation();
			closeLightbox( showFadeLightbox, unRegisterHandlers );
		}
	};
	/** нажатие esc */
	const boundDocumentKeyupHandler: ( event: KeyboardEvent ) => void = ( event ) =>
	{
		if ( event.keyCode === VK_ESC )
		{
			closeLightbox( showFadeLightbox, unRegisterHandlers );
		}
	};

	unRegisterHandlers = (): void =>
	{
		document.removeEventListener( 'click', boundDocumentClickHandler, true );
		document.removeEventListener( 'keyup', boundDocumentKeyupHandler, true );
	};

	buttonClose.addEventListener(
		'click',
		( event: MouseEvent ) =>
		{
			event.stopPropagation();
			closeLightbox( showFadeLightbox, unRegisterHandlers );
		}
	);

	Array.prototype.forEach.call(
		listElementsContainer.children,
		( item: HTMLLIElement, index: number ) =>
		{
			registerHandlersLightbox(
				showFadeLightbox, item, index, boundDocumentClickHandler, boundDocumentKeyupHandler);
		}
	);

	// Событие по закрытию лайтбокса
	listElementsContainer.addEventListener(
		'ShowLightbox:close',
		() =>
		{
			installScrollHeight();
		}	
	);
}

function registerHandlersLightbox(
	showFadeLightbox: ShowFadeLightbox, item: HTMLLIElement, index: number, handlerClick: (event: Event) => void,
	handlerEsc: ( event: KeyboardEvent ) => void ): void
{
	const asideId = item.querySelector('aside').id;

	item.addEventListener(
		'click',
		() =>
		{
			openLightbox( showFadeLightbox, index, handlerClick, handlerEsc );
		}
	);

	if ( window.location.hash === `#${asideId}` )
	{
		openLightbox( showFadeLightbox, index, handlerClick, handlerEsc);
	}
}

/** открыть лайтбокс */
function openLightbox(
	lightbox: ShowFadeLightbox, index: number, handlerClick: (event: Event) => void, 
	handlerEsc: ( event: KeyboardEvent ) => void ): void
{
	if ( !isOpenedLightbox )
	{
		scrollState = window.pageYOffset;
		lightbox.open( index );
		document.addEventListener( 'click', handlerClick, true );
		document.addEventListener( 'keyup', handlerEsc, true );

		isOpenedLightbox = true;
	}
}

/** закрыть лайтбокс */
function closeLightbox( lightbox: ShowFadeLightbox, unRegisterHandlers: () => void ): void
{
	if ( isOpenedLightbox )
	{
		lightbox.close();
		unRegisterHandlers();
		window.location.hash = '';

		isOpenedLightbox = false;
	}
}

function installScrollHeight(): void
{
	if ( isModeMobile() )
	{
		scrollElementTo(window, scrollState, 10);
	}
}

function isModeMobile(): boolean
{
	return ( window.innerWidth < SCREEN_WIDTH_SMALL );
}

export {
	main as default,
}
